import type { PetitionUpdatePageState } from './types';

export const INITIAL_STATE: PetitionUpdatePageState = {
	pageError: undefined,
	beforeSuggestedPetitions: true,
};
